import * as uuid from 'uuid';
export class Uuid {
    static generate(): string {
        return uuid.v4().substring(0, 10);
    }
}
